export enum Routes {
  Homepage = "/",
  HealthCheck = "/healthcheck",

  PrivacyPolicy = "https://joinbonsai.notion.site/Bonsai-Privacy-Policy-ae0222c74506482295c3b5ed6a7e6595",
  TermsOfUse = "https://joinbonsai.notion.site/Bonsai-Terms-of-Use-b1958595d91c40f981b2a73b3013894b",
  TermsAndConditions = "https://joinbonsai.notion.site/Bonsai-Artist-Terms-and-Conditions-ccc0093c6914420da9470ede948318c5",
  Legal = "https://joinbonsai.notion.site/Bonsai-Legal-bd067113f4fa4f63920e92388d1fd6e3",

  Join = "/join",
  Login = "/login",
  RequestMagicLogin = "/login/magic",
  MagicLogin = "/login/magic/[token]",
  Logout = "/logout",
  RequestPassword = "/password/reset",
  ResetPassword = "/password/reset/[token]",
  VerifyEmail = "/email/verify/[token]",

  ShowQuestion = "/q/[id]",

  StripeReturn = "/me/stripe/return",
  StripeRefresh = "/me/stripe/refresh",

  EditProfile = "/me",
  EditPrice = "/me#edit_price",

  Root = "/",
  Symphonic = "/symphonic",
  Discmakers = "/discmakers",
  Profile = "/[username]",
  AskQuestionForm = "/#ask_question_form",

  Faq = "/#faq",
  FaqAudiogram = "/#faq_audiogram",
  FaqPrompt = "/#faq_prompt",
  FaqNft = "/nft",
  FaqRedeem = "/#faq_redeem",
}
